module.exports = __webpack_public_path__ + "img/productp13.ea850956.png";